import { BOOK_INFO, CHAPTERS } from "@/lib/index";
import { introContent } from "@/data/bookContent";
import { motion } from "framer-motion";

export function BookCover() {
  return (
    <div className="relative">
      <div
        className="relative overflow-hidden rounded-2xl min-h-[560px] flex flex-col justify-end mb-16"
        style={{
          boxShadow: "0 24px 60px -12px rgba(0,0,0,0.45)",
          background: "linear-gradient(135deg, oklch(0.28 0.08 240) 0%, oklch(0.24 0.07 240) 50%, oklch(0.20 0.06 240) 100%)",
        }}
      >
        <motion.div
          className="relative z-10 px-10 pb-12 pt-16"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p
            className="text-xs tracking-widest uppercase mb-4 font-sans"
            style={{ color: "oklch(0.65 0.12 50)" }}
          >
            発行：{BOOK_INFO.publicationDate}
          </p>

          <h1
            className="text-5xl md:text-6xl font-bold leading-tight mb-3"
            style={{ color: "oklch(0.98 0.005 60)" }}
          >
            {BOOK_INFO.title}
          </h1>

          <p
            className="text-xl md:text-2xl mb-2"
            style={{ color: "oklch(0.65 0.12 50)" }}
          >
            {BOOK_INFO.subtitle}
          </p>

          {BOOK_INFO.tagline && (
            <p
              className="text-sm mb-8 font-sans"
              style={{ color: "oklch(0.75 0.01 60)" }}
            >
              {BOOK_INFO.tagline}
            </p>
          )}

          <div
            className="w-16 h-px mb-6"
            style={{ background: "oklch(0.65 0.12 50)" }}
          />

          <div>
            <p
              className="text-lg font-sans font-semibold"
              style={{ color: "oklch(0.98 0.005 60)" }}
            >
              著者：{BOOK_INFO.author}
            </p>
            <p
              className="text-sm font-sans mt-1"
              style={{ color: "oklch(0.75 0.01 60)" }}
            >
              {BOOK_INFO.authorTitle}
            </p>
          </div>
        </motion.div>
      </div>

      <motion.section
        className="mb-16"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="flex items-center gap-3 mb-6">
          <div
            className="w-1 h-8 rounded-full"
            style={{ background: "oklch(0.65 0.12 50)" }}
          />
          <h2
            className="text-2xl font-bold"
            style={{ color: "oklch(0.18 0.02 240)" }}
          >
            はじめに：私の立場
          </h2>
        </div>

        <div className="space-y-4">
          {introContent.foreword.map((para, i) => (
            <p
              key={i}
              className={`font-sans leading-relaxed ${
                para === "理由は明確です。" ||
                para === "つまり、何もしないこともリスクです。" ||
                para === "大切なのは、買うか買わないかではなく、買ってよい条件が整っているかです。"
                  ? "font-semibold"
                  : ""
              }`}
              style={{
                color:
                  para === "理由は明確です。" ||
                  para === "つまり、何もしないこともリスクです。" ||
                  para === "大切なのは、買うか買わないかではなく、買ってよい条件が整っているかです。"
                    ? "oklch(0.18 0.02 240)"
                    : "oklch(0.22 0.02 240)",
              }}
            >
              {para}
            </p>
          ))}
        </div>
      </motion.section>

      <motion.section
        className="mb-16"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="flex items-center gap-3 mb-6">
          <div
            className="w-1 h-8 rounded-full"
            style={{ background: "oklch(0.65 0.12 50)" }}
          />
          <h2
            className="text-2xl font-bold"
            style={{ color: "oklch(0.18 0.02 240)" }}
          >
            この資料の結論
          </h2>
        </div>

        <div className="space-y-4">
          {introContent.conclusion.map((para, i) => (
            <p
              key={i}
              className="font-sans leading-relaxed"
              style={{ color: "oklch(0.22 0.02 240)" }}
            >
              {para}
            </p>
          ))}
        </div>
      </motion.section>

      <motion.section
        className="mb-4"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="flex items-center gap-3 mb-6">
          <div
            className="w-1 h-8 rounded-full"
            style={{ background: "oklch(0.65 0.12 50)" }}
          />
          <h2
            className="text-2xl font-bold"
            style={{ color: "oklch(0.18 0.02 240)" }}
          >
            目次
          </h2>
        </div>

        <div
          className="rounded-xl overflow-hidden"
          style={{ border: "1px solid oklch(0.88 0.01 240)" }}
        >
          {CHAPTERS.filter((ch) => ch.number > 0 && ch.number < 8).map((item, i, arr) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById(item.id);
                if (el) {
                  const top =
                    el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: "smooth" });
                }
              }}
              className="flex items-center gap-4 px-6 py-4 transition-colors"
              style={{
                borderBottom:
                  i < arr.length - 1 ? "1px solid oklch(0.88 0.01 240)" : "none",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "oklch(0.65 0.12 50 / 0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              <span
                className="font-sans text-xs font-semibold tracking-wider min-w-[48px]"
                style={{ color: "oklch(0.65 0.12 50)" }}
              >
                第{item.number}章
              </span>
              <span
                className="font-sans text-sm leading-snug"
                style={{ color: "oklch(0.22 0.02 240)" }}
              >
                {item.title.replace(/^第\d+章：/, "")}
              </span>
            </a>
          ))}
        </div>
      </motion.section>
    </div>
  );
}